import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';

const useGetCPListDetail = (id) => {
    return useQuery({
        queryKey: ['promotion-claim', id],
        queryFn: async () => {
            const { data } = await authAxios.get(`/api/v1/promotion-claim/detail/${id}`);
            return data?.data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: true,
    });
};

export default useGetCPListDetail;
